<template>
  <div class="login-wrapper">
    <div class="login-container">
      <div class="logo">
        <a-row type="flex" justify="space-around" align="top">
          <a-col :span="24" class="title-wrap">
            <img src="@/assets/images/headerLogo.png" alt="" />
            <span class="last">知识产权信息服务中心</span>
          </a-col>
        </a-row>
      </div>
      <div class="login-form">
        <component
          :is="curFormConfig"
          :formConfig="formConfig"
          @switchForm="handleSwitch"
        />
      </div>
    </div>
    <div class="login-footer-info-wrap">
      <div class="login-footer-content">华南师范大学 版权所有 粤ICP备05008875号 </div>
    </div>
  </div>
</template>

<script>
import LoginForm from './components/LoginForm.vue'
//import ForgetPswForm from './components/ForgetPswForm.vue'
//import RegisterForm from './components/RegisterForm.vue'
import FooterInfo from '@/components/FooterInfo'
import {
  FORM_CONFIG_LOGIN,
  // FORM_CONFIG_REGISTER,
  // FORM_CONFIG_FORGET
} from './config/form'
import mixinConfigSetting from '@/mixins/mixinConfigSetting'
import mixinLogin from './mixins/index'

export default {
  mixins: [mixinConfigSetting, mixinLogin],
  components: {
    LoginForm,
    FooterInfo
  },
  data() {
    return {
      loading: false,
      curCaptchaPath: '',
      curFormConfig: '',
      formConfig: {}
    }
  },
  created() {
    const { toComponent } = this.$route.query
    if (toComponent) {
      this.handleSwitch('register')
    } else {
      this.initSetting()
    }
  },
  methods: {
    initSetting() {
      //this.$store.dispatch('user/clearAccountInfo') // 清空用户缓存
      this.handleSwitch('login') // 表单配置
    },
    handleSwitch(type) {
      // 表单switch配置
      switch (type) {
        // case 'register':
        //   this.curFormConfig = 'RegisterForm'
        //   this.formConfig = FORM_CONFIG_REGISTER
        //   break
        // case 'forget':
        //   this.curFormConfig = 'ForgetPswForm'
        //   this.formConfig = FORM_CONFIG_FORGET
        //   break
        default:
          this.curFormConfig = 'LoginForm'
          this.formConfig = FORM_CONFIG_LOGIN
          break
      }
    }
  }
}
</script>
